import { z } from 'zod'

export const memberSnoozedSchema = z.object({
  programUuid: z.string().uuid(),
  masterTaskId: z.string(),
  memberStatus: z.string(),
  snoozeDuration: z.number(),
  taskList: z.array(z.object({
    uuid: z.string(),
    type: z.string(),
  })),
})
